module.exports = __webpack_public_path__ + "static/media/4-1-z-mrtvych-vstal.5d69e078.jpg";